class CartReminderPopup extends HTMLElement {
  connectedCallback() {
    this.dialog    = this.querySelector('dialog');
    this.shownKey  = this.dataset.shownKey;
    this.pageKey   = this.dataset.pageKey;
    this.pagesReq  = parseInt(this.dataset.pagesRequired, 10);
    this.delayMs      = parseInt(this.dataset.delayMs, 10);
    this.suppressDays = parseInt(this.dataset.suppressDays, 10) || 7;
    this.itemCount = parseInt(this.dataset.itemCount, 10);
    this.isEditor  = window.Shopify && window.Shopify.designMode;

    this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.close(); });
    this.dialog.addEventListener('cancel', (e) => { e.preventDefault(); this.close(); });
    this.querySelector('.bp-close')?.addEventListener('click', () => this.close());
    this.querySelector('.bp-dismiss')?.addEventListener('click', () => this.close());
    this.querySelector('.bp-cta')?.addEventListener('click', () => {
      this.close();
      setTimeout(() => this.openCart(), 350);
    });

    if (this.isEditor) return;

    try {
      const ts = localStorage.getItem(this.shownKey);
      if (ts && Date.now() - parseInt(ts, 10) < this.suppressDays * 24 * 60 * 60 * 1000) return;
    } catch (e) {}

    if (this.itemCount === 0) {
      try { sessionStorage.setItem(this.pageKey, '0'); } catch (e) {}
      return;
    }

    let pageCount = 0;
    try { pageCount = parseInt(sessionStorage.getItem(this.pageKey), 10) || 0; } catch (e) {}
    pageCount++;
    try { sessionStorage.setItem(this.pageKey, String(pageCount)); } catch (e) {}

    if (pageCount < this.pagesReq) return;

    setTimeout(() => this.show(), this.delayMs);
  }

  isMiniCartOpen() {
    const miniCart = document.getElementById('mini-cart');
    if (miniCart && (miniCart.classList.contains('active') || miniCart.getAttribute('aria-hidden') === 'false')) return true;
    const cartDrawer = document.querySelector('.cart-drawer, .drawer--cart, [data-cart-drawer]');
    if (cartDrawer && (cartDrawer.classList.contains('active') || cartDrawer.classList.contains('open') || cartDrawer.getAttribute('aria-hidden') === 'false')) return true;
    return false;
  }

  show() {
    if (this.isMiniCartOpen()) return;

    this._returnFocus = document.activeElement;

    const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.overflow = 'hidden';
    if (scrollBarWidth > 0) document.body.style.paddingRight = scrollBarWidth + 'px';

    this.dialog.showModal();
    requestAnimationFrame(() => requestAnimationFrame(() => this.dialog.classList.add('bp-visible')));
  }

  close() {
    this.dialog.classList.remove('bp-visible');
    setTimeout(() => {
      this.dialog.close();
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
      this._returnFocus?.focus();
    }, 300);
    if (!this.isEditor) {
      try { localStorage.setItem(this.shownKey, String(Date.now())); } catch (e) {}
    }
  }

  openCart() {
    const cartBtn = document.querySelector('a.header__cart[href*="/cart"]');
    if (cartBtn) { cartBtn.click(); return; }
    const miniCart = document.getElementById('mini-cart');
    if (miniCart) { miniCart.setAttribute('aria-hidden', 'false'); miniCart.classList.add('active'); return; }
    window.location.href = '/cart';
  }
}

customElements.define('cart-reminder-popup', CartReminderPopup);
